import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTheme } from 'styled-components'
import { message } from 'antd'

// Components
import { Button } from '../../../../Reusable/Button'
import { Text } from '../../../../Reusable/Text'
import { FlexColumn, Flex } from '../../../../Reusable/Container'
import { LabeledInput } from '../../../../Reusable/Input'
import { ErrorAlert } from '../../../../Reusable/Alert'
import environment from '../../../../../environment'
import { apiPOSTReq } from '../../../../../Utils/api'
import { InitialCircle } from '../../../../Reusable/InitialCircle'
import hexToRgba from 'hex-to-rgba'
import { dateFormatList, toCurrency } from '../../../../../Utils/util'
import moment from 'moment'

class RecordPayment extends Component {

    constructor(props) {
        super(props)

        this.state = {
            paymentAmount: this.props.bill?.balance,
            paymentDate: moment(),
            paymentDateStr: '',
            loading: false,
            paymentAmountError: false,
            paymentDateError: false,
        }
    }

    handleTextChange = (event) => {
        const target = event.target
        this.setState({ 
            [target.id || target.name]: target.value,
            // Clear errors when user starts typing
            [`${target.id || target.name}Error`]: false
        })
    }

    validateInputs = () => {
        const { paymentAmount, paymentDate } = this.state
        var paymentDateStr = moment(paymentDate).format('YYYY-MM-DD')
        let hasErrors = false

        // Validate payment amount
        if (!paymentAmount || paymentAmount == 0.0) {
            this.setState({ paymentAmountError: true })
            ErrorAlert({ description: "Please enter a payment amount." })
            hasErrors = true
        } else if (isNaN(paymentAmount) || parseFloat(paymentAmount) <= 0) {
            this.setState({ paymentAmountError: true })
            ErrorAlert({ description: "Please enter a valid payment amount greater than zero." })
            hasErrors = true
        } else {
            // Check if amount exceeds remaining balance
            const { bill } = this.props
            if (bill && bill.balance && parseFloat(paymentAmount) > bill.balance) {
                this.setState({ paymentAmountError: true })
                ErrorAlert({ description: `Payment amount cannot exceed remaining balance of $${bill.balance.toFixed(2)}.` })
                hasErrors = true
            }
        }

        // Validate payment date
        if (!paymentDateStr || paymentDateStr.trim() === '') {
            this.setState({ paymentDateError: true })
            ErrorAlert({ description: "Please enter a payment date." })
            hasErrors = true
        } else {
            // Validate date format (yyyy-MM-dd)
            const dateRegex = /^\d{4}-\d{2}-\d{2}$/
            if (!dateRegex.test(paymentDateStr)) {
                this.setState({ paymentDateError: true })
                ErrorAlert({ description: "Please enter a valid date in YYYY-MM-DD format." })
                hasErrors = true
            } else {
                // Validate that it's a valid date
                const date = new Date(paymentDateStr)
                if (isNaN(date.getTime())) {
                    this.setState({ paymentDateError: true })
                    ErrorAlert({ description: "Please enter a valid date." })
                    hasErrors = true
                }
            }
        }

        return !hasErrors
    }

    recordPayment = () => {
        if (!this.validateInputs()) {
            return
        }

        const { bill } = this.props
        var { paymentAmount, paymentDate } = this.state
        var paymentDateStr = moment(paymentDate).format('YYYY-MM-DD')

        if (!bill || !bill.id) {
            ErrorAlert({ description: "No bill selected for payment recording." })
            return
        }

        this.setState({ loading: true })

        const body = {
            billId: bill.id,
            paymentAmount: parseFloat(paymentAmount),
            paymentDateStr: paymentDateStr
        }

        console.log("Recording payment: ", body)

        apiPOSTReq(`${environment.payBaseUrl}/payables/recordpayment`, {}, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                if (err) throw Error(err)
                const data = resp || {}
                if (data.result) {
                    message.success('Payment recorded successfully!')
                    // Clear form
                    this.setState({
                        paymentAmount: '',
                        paymentDateStr: '',
                        paymentAmountError: false,
                        paymentDateError: false
                    })
                    // Call parent callback if provided
                    if (this.props.onPaymentRecorded) {
                        this.props.onPaymentRecorded(data.bill)
                    }
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/recordpayment err", error, resp, body)
                ErrorAlert({ description: error.message || "Sorry, we had trouble recording your payment. Please try again." })
            }
        })
    }

    handleCancel = () => {
        // Clear form and call parent callback if provided
        this.setState({
            paymentAmount: '',
            paymentDateStr: '',
            paymentAmountError: false,
            paymentDateError: false
        })
        
        if (this.props.onCancel) {
            this.props.onCancel()
        }
    }

    disabledDate = (current) => {
        return current > moment().add(1, 'd').startOf('day')
    }

    render() {
        const { bill, theme } = this.props
        const { paymentAmount, paymentDate, loading, paymentAmountError, paymentDateError } = this.state

        if (!bill) {
            return (
                <FlexColumn style={{ width: "100%", padding: "24px" }} center>
                    <Text size='16px' color={theme?.colors?.textSecondary}>
                        No bill selected
                    </Text>
                </FlexColumn>
            )
        }

        return (
            <FlexColumn style={{ width: "100%" }} between>
                <FlexColumn style={{ height: "100%", justifyContent: "flex-start" }} gap='24px'>
                    <Text weight={500} size='20px'>Record a payment</Text>
                    
                    {/* Bill Information */}
                    <FlexColumn gap='8px' style={{ padding: '12px 24px', backgroundColor: hexToRgba(theme?.colors?.primary2, 0.05), borderRadius: '8px' }}>
                        {/* <Text size='14px' weight='600'>Bill Details</Text> */}
                        <Flex between style={{  }}>
                            <Flex start centerHorizontally gap='8px'>
                                <div>
                                    <InitialCircle size={30} name={bill.vendorName} useFirstWordOnly={true} /*logoUrl={getLogoFromDomain(record.sender)}*/ />
                                </div>
                                
                                <FlexColumn start gap='2px'>
                                    <Text weight={500} color={theme.colors.primary2}>{bill.vendorName}</Text>

                                    <Flex centerH start gap='8px'>
                                        <Text size={'14px'} height={'14px'} weight={500} color={hexToRgba(this.props.theme.colors.primary2, 0.5)}>
                                            Bill #{bill.invoiceNumber}
                                        </Text>
                                    </Flex>
                                    
                                </FlexColumn>
                            </Flex>
                            <FlexColumn gap='2px' right>
                                <Text color={theme?.colors?.textSecondary}>Remaining Balance</Text>
                                <Text weight='600' color={theme?.colors?.success}>
                                    ${toCurrency(bill.balance)}
                                </Text>
                            </FlexColumn>
                        </Flex>
                    </FlexColumn>

                    {/* Payment Amount Input */}
                    <LabeledInput
                        label='Payment Amount'
                        key="paymentAmount"
                        id="paymentAmount"
                        name="paymentAmount"
                        placeholder="0.00"
                        value={paymentAmount}
                        autoFocus
                        nomargin
                        type="amount"
                        max={bill.balance}
                        onChange={value => this.setState({"paymentAmount": value})}
                        error={paymentAmountError}
                        instruction={`Maximum amount: $${bill.balance ? bill.balance.toFixed(2) : '0.00'}`}
                        prefix="$"
                    />

                    {/* Payment Date Input */}
                    <LabeledInput
                        label='Payment Date'
                        id="paymentDate"
                        name="paymentDate"
                        value={paymentDate && moment(paymentDate)}
                        nomargin
                        type="date-picker"
                        disabledDate={this.disabledDate}
                        format={dateFormatList}
                        placeholder={moment().format("MM/DD/YYYY")}
                        onChange={(date, dateStr) => this.setState({"paymentDate": date})}
                        error={paymentDateError}
                        instruction="Date when the payment was made"
                    />

                    {/* Payment Method Info */}
                    <Text>
                        This payment will be recorded as manual entry.
                    </Text>
                </FlexColumn>

                {/* Action Buttons */}
                <Flex gap='16px' style={{ marginTop: 24 }} start>
                    <Button 
                        noMargin 
                        solid 
                        loading={loading} 
                        onClick={this.recordPayment} 
                        text={'Record Payment'.toUpperCase()}
                        disabled={!paymentAmount || !paymentDate}
                    />
                    <Button 
                        noMargin 
                        outline 
                        onClick={this.handleCancel} 
                        text={'Cancel'.toUpperCase()}
                        disabled={loading}
                    />
                </Flex>
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        bkStore: state.bookkeepingAppReducer,
        aionStore: state.aionAppReducer,
        bankingStore: state.bankingAppReducer,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(RecordPayment))